import { artConfigBuildings } from "../assetBundles/artConfigBuildings";
import { IdAssetBundleCore } from "../features/loading/IdAssetBundleCore";
import { GetBuildingScaffoldingIso } from "./GetBuildingScaffoldingIso";
import { LoadingBuildingGraphicIso } from "./LoadingBuildingGraphicIso";
import { BF2FinishedScaffolding } from "./outskirts/BF2FinishedScaffolding";
var loadingGraphicsByBuildingId = new Map();
export var GetBuildingFinishedScaffoldingIso = function (data) {
    var _a = data.balancing, xExtent = _a.xExtent, yExtent = _a.yExtent;
    var config = artConfigBuildings["ScaffoldingCelebration" + xExtent + "x" + yExtent];
    var id = data.proto.id;
    try {
        loadingGraphicsByBuildingId.delete(id);
        return BF2FinishedScaffolding(data, config);
    }
    catch (err) {
        if (loadingGraphicsByBuildingId.has(id)) {
            return loadingGraphicsByBuildingId.get(id);
        }
        var loading = new LoadingBuildingGraphicIso({
            building: data,
            bundleId: IdAssetBundleCore.Animations,
            getGraphicsIso: GetBuildingFinishedScaffoldingIso,
            getLoadingIso: GetBuildingScaffoldingIso,
        });
        loadingGraphicsByBuildingId.set(id, loading);
        return loading;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/GetBuildingFinishedScaffoldingIso.ts
// module id = 2205
// module chunks = 3